import { render, staticRenderFns } from "./LessDeliveryList.vue?vue&type=template&id=1fe451d9&scoped=true"
import script from "./LessDeliveryList.vue?vue&type=script&lang=js"
export * from "./LessDeliveryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe451d9",
  null
  
)

export default component.exports